import { render } from "./MfaChallenge.vue?vue&type=template&id=447276bd"
import script from "./MfaChallenge.vue?vue&type=script&lang=js"
export * from "./MfaChallenge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__